import {CandidateList} from '../features/metrics/CandidateList.js';
import {FormatTable} from '../features/metrics/FormatTable.js';
import {MetricGrid} from '../features/metrics/MetricGrid.js';
import {SeriesBars} from '../features/metrics/SeriesBars.js';
import {useMetricsDashboard} from '../features/metrics/useMetricsDashboard.js';

export const MetricsPage = () => {
  const metrics = useMetricsDashboard();
  if (!metrics) {
    return null;
  }

  return (
    <>
      <MetricGrid metrics={metrics} />
      <div className="dm-metrics-grid">
        <SeriesBars series={metrics.series} />
        <CandidateList candidates={metrics.candidates} />
      </div>
      {/* A comparação por formato e idade vem por último e ocupa a largura
          inteira: são oito linhas com cinco colunas, e espremê-la na coluna
          estreita ao lado dos candidatos faria a tabela rolar na horizontal
          dentro de um painel de 250px. */}
      <FormatTable
        performance={metrics.formatPerformance}
        coverage={metrics.coverage}
      />
    </>
  );
};
